import { Action, createReducer, on } from "@ngrx/store";
import { entityTipoEquipamientoLaboratorioLoadFailure, entityTipoEquipamientoLaboratorioLoadRequest, entityTipoEquipamientoLaboratorioLoadSuccess } from "./tipos-equipamiento-laboratorio.actions";
import { EntityTipoEquipamientoLaboratorioState, entityTipoEquipamientoLaboratorioAdapter, initialState } from "./entity-tipos-equipamiento-laboratorio.state";

const reducer = createReducer(
  initialState,
  on(entityTipoEquipamientoLaboratorioLoadRequest, (state) => ({
    ...state,
    hasAddedSuccess: false,
    isLoading: true,
    error: null,
  })),
  on(entityTipoEquipamientoLaboratorioLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error,
  })),
  on(entityTipoEquipamientoLaboratorioLoadSuccess, (state, { items }) =>
    entityTipoEquipamientoLaboratorioAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null,
    })
  )
)

export function tipoEquipamientoLaboratorioReducer(
  state: EntityTipoEquipamientoLaboratorioState | undefined,
  action: Action
) {
  return reducer(state, action);
}
